import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store, { persistor } from "./globals"
import App from "./app"
import reportWebVitals from "./reportWebVitals"

import "bootstrap/dist/css/bootstrap.min.css"
import "typeface-roboto"
import "./assets/css/theme.css"
import "./assets/css/style.css"
import "./style.css"
import "./index.scss"
/*
	De ultimo a proposito: solo corrige el modo oscuro y tiene que poder ganarle
	a cualquier hoja anterior. No toca el modo claro. */
import "./assets/css/oscuro.css"

import { enableMapSet } from 'immer';
import { PersistGate } from "redux-persist/integration/react"
import ErrorBoundary from "./errorBoundary"
import { startVersionWatcher } from "./versionWatcher"
import { instalarGuardiaDeSesion } from "./guardiaDeSesion"
import { version } from "./version"
import PaginaPublica from "./navigation/v2/wappdrive/publico"
import Pagar from "./navigation/public/pagar/pagar"
import Firma from "./navigation/public/firma/firma"
import DatosCliente from "./navigation/public/datos/datos"
import FotoCelular from "./navigation/public/foto/foto"
import { escucharInstalacion, registrarServiceWorker } from "./appMovil/appMovil"

enableMapSet();
instalarGuardiaDeSesion()

// Enlace público de WappCloud (/p/<token>): se abre sin cuenta y sin nada de WAPP alrededor (Esteban, 2026-10-09).
const tokenPublico = (window.location.pathname.match(/^\/p\/([a-z0-9]{24})\/?$/) || [])[1]
// "Reporta tu pago" (/pagar y /pagar/<plantel>): pública, sin sesión ni barra de WAPP (2026-10-10).
const pagar = window.location.pathname.match(/^\/pagar(?:\/([a-z]{2,8}))?\/?$/i)
// Firma del contrato desde el celular (/firma/<token>, 2026-10-15): pública como /pagar.
const firma = (window.location.pathname.match(/^\/firma\/([a-f0-9]{32})\/?$/) || [])[1]
// Formulario del cliente (/datos/<token>, 2026-10-19): llena sus datos de matrícula desde el enlace de WhatsApp.
const datosCliente = (window.location.pathname.match(/^\/datos\/([a-f0-9]{32})\/?$/) || [])[1]
// "Usar el celular" (/foto/<token>, 2026-10-19): la asesora toma con el celular la foto que pide la Matrícula en la PC.
const fotoCelular = (window.location.pathname.match(/^\/foto\/([a-f0-9]{32})\/?$/) || [])[1]
const esPublica = Boolean(tokenPublico || pagar || firma || datosCliente || fotoCelular)

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render
	(tokenPublico ? <React.StrictMode><PaginaPublica token={tokenPublico} /></React.StrictMode> :
		pagar ? <React.StrictMode><Pagar slug={pagar[1]} /></React.StrictMode> :
		firma ? <React.StrictMode><Firma token={firma} /></React.StrictMode> :
		datosCliente ? <React.StrictMode><DatosCliente token={datosCliente} /></React.StrictMode> :
		fotoCelular ? <React.StrictMode><FotoCelular token={fotoCelular} /></React.StrictMode> :
		<React.StrictMode>
			<Provider store={store}>
				<PersistGate loading={<div>Cargando...</div>} persistor={persistor}>
					<BrowserRouter>
						<ErrorBoundary>
							<App />
						</ErrorBoundary>
					</BrowserRouter>
				</PersistGate>
			</Provider>
		</React.StrictMode >
	)

reportWebVitals()

//Qué versión corre esta pestaña: lo primero que hay que saber cuando alguien reporta "la app vieja".
console.info("WAPP " + version)

// En /pagar no: recargar a media captura (al volver de la cámara) le borraría lo escrito al alumno.
if (!pagar && !firma) startVersionWatcher()

// WAPP instalable con avisos (appMovil/appMovil.ts). El service worker solo muestra avisos: no cachea nada.
escucharInstalacion()
if (!esPublica) {
	if (document.readyState === "complete") registrarServiceWorker()
	else window.addEventListener("load", () => { registrarServiceWorker() })
}
